import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F1120pcSchIService {

  constructor(private http: HttpClient) { }

  // CRITICAL: Service Method Signature
  saveF1120pcSchIForm(
    baseUrl: string,
    mainData: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {

    // Build payload EXACTLY like original AngularJS with proper fallbacks
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);

    // Essential parameters with fallbacks - match AngularJS exactly
    params.jsonSettings = JSON.stringify({
      "tax_year": rowData.TAX_YEAR,
      "scenario": rowData.SCENARIO,
      "jcd_key": rowData.JCD_KEY,
      "combination_key": rowData.COMBINATION_KEY,
      "trans_type_key": mainData[0].editrows[0][0].trans_type_key
    });
    params.jsonObj = JSON.stringify(mainData);
    params.tax_year = filterParams.tax_year || params.tax_year || rowData.TAX_YEAR;
    params.scenario = filterParams.scenario || params.scenario || rowData.SCENARIO;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || rowData.JCD_KEY || 250; // AngularJS factory fallback
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.is_issue_key_enabled = "N";
    params.process_name = filterParams.process_name || "1120PC Sch I";
    params.combination_key = rowData.COMBINATION_KEY;
    params.trans_type_key = mainData[0].editrows[0][0].trans_type_key;

    // Include checkLockedbj from rowData (NOT hardcoded) - match AngularJS format exactly
    const checkLockedbj = [{
      "leid": rowData.LEID,
      "me_code": rowData.ME,
      "combination_key": rowData.COMBINATION_KEY
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // MUST use application/x-www-form-urlencoded (NOT application/json):
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = baseUrl + "/saveJsonObject?action_code=nkepph";

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}

